import React, { useState, useContext, useEffect } from 'react'
import { Formik, Field, FieldArray, ErrorMessage } from 'formik'
import { Form, Row, Col, Button } from 'react-bootstrap'

import api from '../../services/api'
// import AlertCustom from '../alertCustom/index.js'
import BtnLoader from '../buttons/loader/index.js'
import onSubmitSearch from '../ILEntitiesSearch/index.js'
import StoreContext from '../../components/storage/context'
import errorHandlerShow from '../errorHandlerShow/index.js'
import AutoCompleteFields from '../autoCompleteFields/index.js'
import SelectWithValidation from '../fields/selectWithValidation/index.js'
import ControlWithValidation from '../fields/controlWithValidation/index.js'
import IntegrationLayerTableFields from '../integrationLayerTableFields/index.js'
import SelectWithValidationInfo from '../fields/selectWithValidationInfo/index.js'
import ControlWithValidationInfo from '../fields/controlWithValidationInfo/index.js'
import AutoCompleteFieldsIntegrationLayer from '../autoCompleteFieldsIntegrationLayer/index.js'

// schema validation
import * as schema from '../schemaValidation/index.js'

import './styles.css'

const IntegrationLayerEntity = ({
    entity,
    setEntity,
    setAlert,
    setShowAlert,
    fields,
    setFields,
    emptyEntity,
    readOnly,
    typeForm,
    setShowEntityForm,
    query,
    setQuery,
    setEntities,
    setLoadingData
}) => {
    const { token, pk_user, setToken } = useContext(StoreContext);
    const [tableHidden, setTableHidden] = useState("mf-register-hidden");

    // start page the top
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // loading
    const [loading, setLoading] = useState(false);

    // edit fields
    const handleSaveFields = (value) => setFields(value);


    /**
     * check if data it's ok
     */
    const checkData = (values) => {
        let hasError = true

        // check if all fields it's ok
        if (fields.filter(item => item.status === false).length > 0) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações', 
                message: 'Complete as informações de cada campo, use o icone lápis para editar a linha. \
                Após finalizado, salve novamente. \
                Obs.: Note que a coluna status deve estar com status ok',
                type: 'danger',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
        // check if fields have at least one field
        } else if ( fields.length <= 0) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações', 
                message: 'O entidade precisa ter pelo menos um campo, adicione e salve novamente. \
                Obs.: Note que a coluna status indica se o cadastro está correto.',
                type: 'danger',
                options_btn: []
            })
        
            // show alert to users
            setShowAlert(true)
        } else if ( values.tag_set.length < 2) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações', 
                message: 'No campo tag_set as keys project e platform são obrigatórias.',
                type: 'danger',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
        } else if ( values.tag_set.filter(item => item.Key === 'project' | item.Key === 'platform').length < 2) {
            setAlert({
                header: 'Ops... ficou faltando algumas informações', 
                message: 'No campo tag_set as keys project e platform são obrigatórias.',
                type: 'danger',
                options_btn: []
            })

            // show alert to users
            setShowAlert(true)
        } else {
            hasError = false
        }

        return !hasError
    }


    const handlePortalToDynamo = (value) => {
        // apply year conversion
        value = value.replace('yyyy', '%Y');
        value = value.replace('yy', '%y');

        // apply month conversion
        value = value.replace('mmmm', '%B');
        value = value.replace('mmm', '%b');
        value = value.replace('mm', '%m');

        // apply day conversion
        value = value.replace('dddd', '%A');
        value = value.replace('ddd', '%a');
        value = value.replace('dd', '%01234');
        value = value.replace('d', '%w');

        // apply hours conversion
        value = value.replace('H', '%H');

        // apply minutes conversion
        value = value.replace('M', '%M');

        // apply seconds conversion
        value = value.replace('S', '%S');

        // apply microseconds conversion
        value = value.replace('f', '%f');

        // apply custom conversion
        value = value.replace('%01234', '%d');

        return value
    }


    const handleFieldsDynamo = (fieldsDynamo) => {
        const fields_custom = fieldsDynamo.map(({id, status, ...myfield}) => {
            if (myfield.data_type === 'date' | myfield.data_type === 'datetime') {
                myfield.mask_field = handlePortalToDynamo(myfield.mask_field)
            }
            return myfield
        })

        return fields_custom
    }


    const handleShowResponse = (response) => {
        const status = response['entity']['status']
        delete response.entity['status']

        if (status === 'update') {
            setAlert({
                header: 'Status do cadastro da entidade:', 
                message: response.message,
                type: 'success',
                options_btn: []
            })
        } else if (status === 'insert') {
            setAlert({
                header: 'Status do cadastro da entidade:',
                message: response.message,
                type: 'success',
                options_btn: []
            })

            // clean data after insert with successful
            setFields([])
            setEntity(emptyEntity)
            setShowEntityForm(false)
            // pesquisa no dynamodb
            onSubmitSearch(
                query,
                setLoading,
                setLoadingData,
                setEntities,
                setQuery,
                pk_user,
                token,
                setToken,
                setAlert,
                setShowAlert
            )
        } else {
            setAlert({
                header: 'Ocorreu um erro ao cadastrar/atualizar a entidade:',
                message: response.message,
                type: 'success',
                options_btn: []
            })
        }
    }


    const handleEntityRequest = (values) => {
        const pattern_date = handlePortalToDynamo(values.pattern_date)
        const schedule_interval = handleCrontab(
            values.crontab,
            values.schedule_interval
        )

        var entity_request = {
            ...values,
            chunk_size: parseInt(values.chunk_size),
            schedule_delta: parseInt(values.schedule_delta),
            header: values.header === "true",
            active: values.active === "true",
            open_ticket: values.open_ticket === "true",
            pattern_date: pattern_date
        }

        entity_request = {...entity_request, schedule_interval: schedule_interval}
        // remove keys
        delete entity_request.crontab

        return entity_request
    }


    const onSubmitEntity = (values) => {
        setLoading(true)
        setEntity({...values})

        if (checkData(values)) {
            const entity_request = handleEntityRequest(values)
            const fields_request = handleFieldsDynamo(fields)
            var data = ''

            if (typeForm === "newEntity") {
                data = {'data': {...entity_request, fields: fields_request, status: 'insert'}}
            } else if (typeForm === "editEntity") {
                data = {'data': {...entity_request, fields: fields_request, status: 'update'}}
            }

            // Call POST request to integration layer
            console.log('data', data, 'typeForm', typeForm)
            api.post('integration-layer/entities', data, {
                params: {'pk_user': pk_user},
                headers: {'Authorization': token}
            })
            .then(response => {
                handleShowResponse(response.data)

                // show alert to users
                setShowAlert(true)
                setLoading(false)
                window.scrollTo(0, 0)
            })
            .catch(error => {
                console.log(error)
                errorHandlerShow(error, setToken, setAlert, setShowAlert)
                setLoading(false)
            })
        } else {
            setLoading(false)
        }
    }


    const handleCrontab = (crontab, schedule_interval) => {
        var schedule = schedule_interval
        if(['crontab'].includes(schedule)) {
            schedule = crontab
        }
        return schedule
    }

    //category_id, group_id, open_ticket

    return (
        <div className="IL-entity-container">
            <Formik
                initialValues={{
                    entity_name: entity.entity_name, 
                    system_name: entity.system_name, 
                    chunk_size: entity.chunk_size, 
                    pattern_file: entity.pattern_file, 
                    extension_file: entity.extension_file,
                    account_destination: entity.account_destination,
                    datalake_destination: entity.datalake_destination,
                    datalake_table_name: entity.datalake_table_name,
                    email_notification_account: entity.email_notification_account,
                    pattern_date: entity.pattern_date,
                    type_file: entity.type_file,
                    encoding: entity.encoding,
                    delimiter: entity.delimiter,
                    content_delimiter: entity.content_delimiter,
                    source_path: entity.source_path,
                    schedule_interval: handleScheduleInterval(entity).schedule_interval,
                    crontab: handleScheduleInterval(entity).crontab,
                    schedule_delta: entity.schedule_delta,
                    active: entity.active,
                    header: ["true", "false"].includes(entity.header) ? entity.header : "true",
                    tag_set: entity.tag_set ? entity.tag_set : [],
                    category_id: entity.category_id,
                    group_id: entity.group_id,
                    processed_path: entity.processed_path,
                    open_ticket: entity.open_ticket
                }}
                validationSchema={schema.IntegrationLayerSchema}
                onSubmit={(values) => onSubmitEntity(values)}
                validateOnChange={true}
                validateOnBlur={true}
                enableReinitialize={true}
            >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                setValues,
                touched,
                isValid,
                errors,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <RowsIntegrationLayer
                        values={values}
                        setValues={setValues}
                        errors={errors}
                        handleChange={handleChange}
                        touched={touched}
                        readOnly={readOnly}
                    />

                    {!readOnly ?
                        <AutoCompleteFields
                            handleSaveFields={handleSaveFields} 
                            setTableHidden={setTableHidden}
                            setAlert={setAlert}
                            setShowAlert={setShowAlert}
                            delimiter={values.delimiter}
                        />
                    : null}

                    <IntegrationLayerTableFields
                        fields={fields}
                        setFields={setFields}
                        readOnly={readOnly}
                        setAlert={setAlert}
                        setShowAlert={setShowAlert}
                    />

                    <div className="mf-register-next mf-register-next-only">
                        <BtnLoader
                            loading={loading}
                            messageNotLoading="Salvar"
                            messageLoading="Salvando"
                            style={"btn-loader-135px"}
                            variant={"success"}
                            hasOnClick={true}
                        />
                    </div>
                </Form>
            )}
            </Formik>
        </div>
    );
}


/**
 * ROWS FORM
 * rows to requesting form
 */
 const RowsIntegrationLayer = ({
    values,
    setValues,
    errors,
    touched,
    handleChange,
    readOnly
}) => {
    var tooltip = ""
    var scheduleDelta = ""

    if (values.schedule_interval === '@daily') {
        tooltip = "Esse campo representa a data do arquivo que será ingerido. \n N representa 'd-n' (dia atual - qtd de dias) \n N ∈ { d-1, d-2, d-3, ..., d-7 }"
        scheduleDelta = ['', ...Array.from({length: 7}, (_, i) => i + 1)]
    } else if (values.schedule_interval === '@weekly') {
        tooltip = "Esse campo representa a data do arquivo que será ingerido. \n N representa um dia da semana: \n 1 igual a sábado anterior; \n 2 igual a sexta-feira anterior; \n ... \n 7 igual a domingo anterior"
        scheduleDelta = ['', ...Array.from({length: 7}, (_, i) => i + 1)]
    } else if (values.schedule_interval === '@monthly') {
        tooltip = "Esse campo representa a data do arquivo que será ingerido. \n N representa um dia do mês de 1 a 28"
        scheduleDelta = ['', ...Array.from({length: 28}, (_, i) => i + 1)]
    } else if (values.schedule_interval === "crontab") {
        tooltip = "Esse campo representa a data do arquivo que será ingerido.\n1) Se rodar diariamente:\n N representa 'd-n' (dia atual - qtd de dias) \n N ∈ { d-1, d-2, d-3, ..., d-7 } \n\n2) Se rodar semanalmente:\n N representa um dia da semana: \n 1 igual a sábado anterior; \n 2 igual a sexta-feira anterior; \n ... \n 7 igual a domingo anterior \n\n3) Se rodar mensalmente:\n N representa um dia do mês de 1 a 28"
        scheduleDelta = ['', ...Array.from({length: 28}, (_, i) => i + 1)]
    } else {
        tooltip  = ""
        scheduleDelta = ['']
    }

    return (
    <div>

        <Row className="mb-3">

            <ControlWithValidation Col={Col}
                type="text"
                label="entity_name"
                name="entity_name"
                placeholder=""
                value={values.entity_name}
                error={errors.entity_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="system_name"
                name="system_name"
                placeholder=""
                value={values.system_name}
                error={errors.system_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation 
                key="chunk_size"
                Col={Col}
                type="number"
                label="chunk_size"
                name="chunk_size"
                placeholder=""
                value={values.chunk_size}
                error={errors.chunk_size}
                handleChange={handleChange}
                options={["", 256000000, 512000000]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidation
                key="datalake_destination"
                Col={Col}
                type="number"
                label="datalake_destination"
                name="datalake_destination"
                placeholder=""
                value={values.datalake_destination}
                error={errors.datalake_destination}
                handleChange={handleChange}
                options={['', 'trusted', 'refined', 'redshift']}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <Col xs={1}/>

        </Row>

        <Row className="mb-3">
            <ControlWithValidation Col={Col}
                type="text"
                label="datalake_table_name"
                name="datalake_table_name"
                placeholder=""
                value={values.datalake_table_name}
                error={errors.datalake_table_name}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <ControlWithValidation Col={Col}
                type="text"
                label="pattern_file"
                name="pattern_file"
                placeholder="Ex.: {entity_name}_{pattern_date}"
                value={values.pattern_file}
                error={errors.pattern_file}
                handleChange={handleChange}
                readOnly={readOnly}
            />

            <SelectWithValidation 
                key="extension_file"
                Col={Col}
                type="text"
                label="extension_file"
                name="extension_file"
                placeholder=""
                value={values.extension_file}
                error={errors.extension_file}
                handleChange={handleChange}
                options={["", "csv", "txt", "json", "xml"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidationInfo Col={Col}
                type="text"
                label="pattern_date"
                name="pattern_date"
                placeholder="Ex.: yyyymmdd"
                value={values.pattern_date}
                error={errors.pattern_date}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
                custom_style="select-tooltip"
                tooltip="Considere o seguinte padrão:&#0010;yyyy=2022 (ano 4 digitos);&#0010;yy=22 (ano 2 digitos);&#0010;mm=04 (mês 2 digitos);&#0010;mmm=Abr (Nome do mês abreviado);&#0010;mmmm=April (Nome do mês completo);&#0010;d=6 (dia da semana);&#0010;dd=30 (dia do mês);&#0010;ddd=Sat (Nome do dia da semana abreviado);&#0010;dddd=Saturday (Nome do dia da semana completo);&#0010;Exemplo: 20220430 => yyyymmdd."
            />

            <SelectWithValidation 
                key="type_file"
                Col={Col}
                type="text"
                label="type_file"
                name="type_file"
                placeholder=""
                value={values.type_file}
                error={errors.type_file}
                handleChange={handleChange}
                options={["", "csv", "txt", "json", "xml"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />
        </Row>

        <Row className="mb-3">

            <ControlWithValidation
                key="encoding"
                Col={Col}
                type="text"
                label="encoding"
                name="encoding"
                placeholder=""
                value={values.encoding}
                error={errors.encoding}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidation
                key="delimiter"
                Col={Col}
                type="text"
                label="delimiter"
                name="delimiter"
                placeholder=""
                value={values.delimiter}
                error={errors.delimiter}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidation
                key="content_delimiter"
                Col={Col}
                type="text"
                label="content_delimiter"
                name="content_delimiter"
                placeholder=""
                value={values.content_delimiter}
                error={errors.content_delimiter}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <ControlWithValidation
                key="source_path"
                Col={Col}
                type="text"
                label="source_path"
                name="source_path"
                placeholder="Ex.: {system_name}/{entity_name}/{pattern_date}"
                value={values.source_path}
                error={errors.source_path}
                handleChange={handleChange}
                readOnly={readOnly}
            />
        </Row>

        <Row className="mb-3">
            <SelectWithValidationInfo 
                key="account_destination"
                Col={Col}
                type="text"
                label="account_destination"
                name="account_destination"
                placeholder=""
                value={values.account_destination}
                error={errors.account_destination}
                handleChange={handleChange}
                options={["", "none", "coe", "corp", "both", "empty"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
                tooltip="Esse campo representa o destino do arquivo, sendo origem 'Source'.&#0010;none: da source para distribution da integration layer;&#0010;coe: da source para raw > trusted > refined + redshift da conta coe;&#0010;corp: da source para landing da conta corporativa;&#0010;both: conta coe + conta corporativa;&#0010;empty: none"
            />

            <SelectWithValidation 
                key="header"
                Col={Col}
                type="text"
                label="header"
                name="header"
                placeholder=""
                value={values.header}
                error={errors.header}
                handleChange={handleChange}
                options={["", "true", "false"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidation 
                key="active"
                Col={Col}
                type="text"
                label="active"
                name="active"
                placeholder=""
                value={values.active}
                error={errors.active}
                handleChange={handleChange}
                options={["", "true", "false"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
            />

            <SelectWithValidationInfo 
                key="schedule_interval"
                Col={Col}
                type="text"
                label="schedule_interval"
                name="schedule_interval"
                placeholder=""
                value={values.schedule_interval}
                error={errors.schedule_interval}
                handleChange={handleChange}
                options={["", "@daily", "@weekly", "@monthly", "crontab"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
                tooltip="Esse campo representa a periodicidade da DAG."
            />

            {values.schedule_interval === "crontab" ?
                <ControlWithValidationInfo
                    key="crontab"
                    Col={Col}
                    type="text"
                    label="crontab"
                    name="crontab"
                    placeholder="* * * * *"
                    value={values.crontab}
                    error={errors.crontab}
                    handleChange={handleChange}
                    readOnly={readOnly}
                    valueColumn={1}
                    custom_style="select-tooltip"
                    tooltip="*&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;*&nbsp;&nbsp;* (mm hh dd MM ss)&#0010;mm = minuto (0-59)&#0010;hh = hora (0-23)&#0010;dd = dia (1-31)&#0010;MM = mes (1-12)&#0010;ss = dia_da_semana (0-7) (sunday=0)&#0010;"
                />
            : null}

            <SelectWithValidationInfo 
                key="schedule_delta"
                Col={Col}
                type="number"
                label="schedule_delta"
                name="schedule_delta"
                placeholder=""
                value={values.schedule_delta}
                error={errors.schedule_delta}
                handleChange={handleChange}
                options={scheduleDelta}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
                custom_style="select-tooltip"
                // tooltip="schedule_interval=@daily&#0010;N representa uma quantidade de dias&#0010;'d-N' sendo N ∈ { 1, 2, 3, ..., 7 }&#0010;schedule_interval=@weekly&#0010;N representa um dia da semana:&#0010;N ∈ { 7: domingo anterior, 6: segunda-feira anterior, ..., 1: sábado anterior };&#0010;schedule_interval=@monthly&#0010;N representa um dia do mês&#0010;N ∈ { 1, 2, 3, ..., 28 }"
                tooltip={tooltip}
            />

            <Col xs={3} />
        </Row>

        <Row className="mb-3">
            <ControlWithValidationInfo
                key="email_notification_account"
                Col={Col}
                type="text"
                label="E-mail para notificação"
                name="email_notification_account"
                placeholder=""
                value={values.email_notification_account}
                error={errors.email_notification_account}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={4}
                custom_style="select-tooltip"
                tooltip="Deve-se preencher caso não tenha grupo AD pra abertura de chamado.&#0010;As notificações de falhas serão enviadas para os e-mails preenchidos abaixo.&#0010;Em caso de mais de um e-mail, separar por vírgula."
            />

            <ControlWithValidationInfo
                key="group_id"
                Col={Col}
                type="text"
                label="group_id"
                name="group_id"
                placeholder=""
                value={values.group_id}
                error={errors.group_id}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={3}
                custom_style="select-tooltip"
                tooltip="O grupo AD será usado para abertura de chamado automático,&#0010;quando houver falhas na ingestão da entidade.&#0010;Ex.: TD-NUMENIT-PROJETO-ZEUS"
            />

            <ControlWithValidationInfo
                key="category_id"
                Col={Col}
                type="text"
                label="category_id"
                name="category_id"
                placeholder=""
                value={values.category_id}
                error={errors.category_id}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={3}
                custom_style="select-tooltip"
                tooltip="As notificações de falhas serão direcionadas conforme o category_id.&#0010;Ex.: SISTEMAS.DEMAIS SISTEMAS.EXTRATORES PROCUREMENT.ERRO"
            />

            <SelectWithValidationInfo 
                key="open_ticket"
                Col={Col}
                type="text"
                label="open_ticket"
                name="open_ticket"
                placeholder=""
                value={values.open_ticket}
                error={errors.open_ticket}
                handleChange={handleChange}
                options={["", "true", "false"]}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={2}
                tooltip="Se devemos abrir chamado quando não temos arquivos:&#0010;true = abre chamado&#0010;false = não abre chamado."
            />

        </Row>

        <Row className="mb-3">
            <ControlWithValidationInfo
                key="processed_path"
                Col={Col}
                type="text"
                label="processed_path"
                name="processed_path"
                placeholder=""
                value={values.processed_path}
                error={errors.processed_path}
                handleChange={handleChange}
                readOnly={readOnly}
                typeColumn="xs"
                valueColumn={4}
                custom_style="select-tooltip"
                tooltip="Deve-se indicar o path completo do SFTP onde os arquivos&#0010;devem ser movidos após serem processados pela integration layer."
            />

            <Col xs={2} />
        </Row>

        <TagFields
            values={values}
            setValues={setValues}
            errors={errors}
            handleChange={handleChange}
            readOnly={readOnly}
            touched={touched}
        />

    </div>
)
    }


const TagFields = ({ values, setValues, errors, touched, handleChange, readOnly }) => {
    const [tags, setTags] = useState([]);

    const onAddNewTag = () => {
        const tag_set = [...values.tag_set];
        tag_set.push({Key: '', Value: ''})
        setValues({ ...values, tag_set });
    }

    const onRemoveTag = (index, item) => {
        const tag_set = values.tag_set.filter(function(value, index_, arr){ 
            return index_ != index;
        });

        setValues({ ...values, tag_set });
    }

    return ( 
        <div className='ilr-container-tags'>
            <TagFieldWithoutLabel
                onRemoveTag={onRemoveTag}
                values={values}
                errors={errors}
                handleChange={handleChange}
                readOnly={readOnly}
                touched={touched}
            />

            {!readOnly ?
                <Button className='btn-icon-text btn-next' variant="light" onClick={onAddNewTag}>
                    Add new tag
                </Button>
            : null}
        </div>
    )
}


const TagFieldWithoutLabel = ({ onRemoveTag, values, errors, touched, readOnly }) => (
    <FieldArray name="tag_set">
        {() => (values.tag_set.map((tags, i) => {
            const tagsErrors = errors.tag_set?.length && errors.tag_set[i] || {};
            const tagsTouched = touched.tag_set?.length && touched.tag_set[i] || {};
            return (
                <div>
                    {i === 0 ?
                    <div>
                        <Row className="mb-3">
                            <p>tag_set (keys project e platform são obrigatórias).</p>
                        </Row>
                        <Row className="mb-3">
                            <Col md>
                                <label>Key</label>
                            </Col>
                            <Col md>
                                <label>Value</label>
                            </Col>
                            <Col md />
                        </Row>
                    </div>
                    : null}

                    <Row className="mb-3">                     
                        <Col md>
                            <Field readOnly={readOnly} name={`tag_set.${i}.Key`} type="text" className={'form-control' + (tagsErrors.key && tagsTouched.key ? ' is-invalid' : '' )} />
                            <ErrorMessage name={`tag_set.${i}.Key`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            <Field readOnly={readOnly} name={`tag_set.${i}.Value`} type="text" className={'form-control' + (tagsErrors.value && tagsTouched.value ? ' is-invalid' : '' )} />
                            <ErrorMessage name={`tag_set.${i}.Value`} component="div" className="invalid-feedback" />
                        </Col>
                        <Col md>
                            {!readOnly ?
                                <Button className='btn-tag-remove-without-label' variant="light" onClick={() => onRemoveTag(i, tags)}>
                                    Remover
                                </Button>
                            : null}
                        </Col>
                    </Row>
                </div>
            );
        }))}
    </FieldArray>
)


const handleScheduleInterval = (entity) => {
    var response = {crontab: entity.crontab, schedule_interval: entity.schedule_interval}
    if(!['@daily', '@weekly', '@monthly', '', 'crontab'].includes(entity.schedule_interval)) {
        response = {crontab: entity.schedule_interval, schedule_interval: 'crontab'}
    }
    return response
}

export default IntegrationLayerEntity;
